import { request as httpRequest } from './http-library.js';
import publicConfig from '../public-config.js';
const entitlementsHost = publicConfig.external_address;

export const Entitlements = {

  createAttachment (entitlementId, ssoId, token, callback) {
    const attachBody = {
      entitlement_id: entitlementId,
      ns: 'profiles',
      key: 'SSOid',
      value: ssoId
    };

    const requestParams = {
      host: entitlementsHost,
      path: '/v1/entitlements/attachments',
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      }
    };

    httpRequest(requestParams, function (response) {
      callback(response);
    }, attachBody);
  },

  readEntitlement (externalId, callback) {
    const requestParams = {
      host: entitlementsHost,
      path: '/v1/entitlements/external_id/' + externalId,
      method: 'GET'
    };

    httpRequest(requestParams, function (response) {
      callback(response);
    }, null);
  },

  readUserEntitlement (ssoId, token, callback) {
    const requestParams = {
      host: entitlementsHost,
      path: '/v1/entitlements/attachments/profiles/' + ssoId,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      }
    };

    httpRequest(requestParams, function (response) {
      callback(response);
    }, null);
  },

  readEntitlementQuery (query, accessToken, callback) {
    const requestParams = {
      host: entitlementsHost,
      path: `/v1/entitlements?${query}`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    };

    httpRequest(requestParams, function (response) {
      callback(response);
    }, null);
  }

};
